<template>
  <div id="docTemplateBlock" class="fading-container fade">
    <input type="hidden" name="oneDocLoaded" id="oneDocLoaded" value="false">
    <input type="hidden" name="oneDocCompleted" id="oneDocCompleted" value="false">
    <iframe id='oneDoCSpa' class="spaIframe" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
  name: 'OneDocSpa',
  mounted: function () {
    if (this.$store.state.oneDocConfig && this.$store.state.oneDocConfig.spaActive) {
      document.getElementById('oneDoCSpa').src = this.$store.state.oneDocConfig.spaUrl
    }
  }
}
</script>
<style>
#docTemplateBlock {
  padding-left: 1rem;
  padding-right: 1rem;
  background: white;
}

.spaIframe {
  width: 100%;
  height: auto;
  border: none;
}

.fading-container {
  opacity: 1;
  transition: opacity 1s;
}

.fading-container.fade {
  opacity: 0;
}
</style>
